<div #content id="global">
  <div class="timeline-container" #timeline id="planning-gantt" [style.width]="(calendarWidth) + 'px'">
    <div class="tree" [style.top]="scrollTop * -1 + 'px'" [style.width]="hourWidth + 'px'" cdkDropList>
      <ng-container *ngFor="let hour of hoursOfDay">
        <div class="tree-child">
          <div class="hour-label" [ngClass]="{'half-hour': hour.isHalfHour}">{{ hour.label }}</div>
        </div>
      </ng-container>
    </div>

    <div class="board" id="timeline-board" #board [style.left]="hourWidth + 'px'">
      <div class="graph-container" id="graph-container" [style.width]="(graphWidth) + 'px'"
        [style.transform]="'translateX(' + -scrollLeft + 'px)'" #graph>

        <div *ngFor="let w of weeks; let i = index;" [style.left]="w.position*hourSize + 'px'"
          [style.width]="daySize * 2 + 'px'" [style.height]="totalHoursHeight + 'px'" class="week"></div>
        <div *ngFor="let d of days; let index; trackBy: trackByDay; let i = index;"
          [style.left]="d.position*hourSize + 'px'" [style.height]="totalHoursHeight + 'px'" class="vertical">
        </div>

        <div class="lines-container">
          <ng-container *ngFor="let line of hoursOfDay; let index = index">
            <div *ngIf="!line.hidden" class="line" (mousedown)="onMouseDown($event, index)"
              (mousemove)="onMouseMove($event, index)"></div>
          </ng-container>

          <div *ngFor="let cell of selectedCells" class="selection-box" [style.left]="getScaled(cell.left) + 'px'"
            [style.top]="cell.top + 'px'" [style.width]="getScaled(cell.width) + 'px'"
            [style.height]="cell.height + 'px'">
          </div>

          <!-- Affichage des metrics -->
          <div *ngFor="let m of metrics;let _index = index" class="graph-metric"
            [style.left]="getScaled(m.left ?? 0) + 'px'" [style.top]="(m.top ?? 0) + 'px'"
            (mouseleave)="onMouseLeaveInfo()" (mouseenter)="onMouseEnterInfo($event, m)" (click)="onClickMetric(m)"
            [class.ignore-pointer-events]="isSelecting">
            <div class="graph-bar {{currentScale}}" [style.width]="getScaled(m.width ?? 0) + 'px'"
              [style.height]="(m.height ?? 0) + 'px'" [style.background]="m.color">
              <div class="line-label">{{m.label}}</div>
            </div>
          </div>

          <!-- Affichage de la barre de temps actuelle -->
          <div class="current-time-bar" [style.top]="currentBarTop + 'px'"
            [ngStyle]="{'width': dottedBarWidth == 0 ? '100%' : getScaled(dottedBarWidth) + 'px'}">
            <!-- Partie pointillée -->
            <div class="dotted-bar" [style.width]="dottedBarWidth != 0 ? getScaled(dottedBarWidth) + 'px' : '100%'">
            </div>
            <!-- Partie pleine -->
            <div *ngIf="solidBarWidth != 0" class="solid-bar" [style.width]="getScaled(solidBarWidth) + 'px'"></div>
          </div>

          <div *ngIf="hoverInfo">
            <ng-container
              *ngTemplateOutlet="infoBoxTemplate; context: { metric: metric, showRawData: showRawData }"></ng-container>
          </div>

          <!-- //////////////////////////////////// -->

          <ng-template #infoBoxTemplate let-metric="metric" let-showRawData="showRawData">
            <div id="info-box" *ngIf="metric" class="info-box" [style.left]="getScaled(metric.left) + 'px'"
              [style.top]="(metric.top + metric.height) + 'px'">
              <div class="info-box-container">
                <div *ngIf="!showRawData">

                  <div class="row space">
                    <div class="column">
                      <div *ngIf="metric.payload.title" class="metric-title ">
                        <strong
                          [style.color]="metric.color ? metric.color : metric.payload.color">{{metric.payload.title}}</strong>
                      </div>
                      
                      <div *ngIf="metric.name" class="metric-name space-vertical">
                        {{metric.name}}
                      </div>
                    </div>

                  </div>
                  <hr>

                  <!--Tracker / Unit-->
                  <div class="row space-row">
                    <mat-icon *ngIf="metric.tracker || metric.unit || metric.trackerName || metric.unitName"
                      class="center-icon space-icon"
                      [style.color]="metric.color ? metric.color : metric.payload.color">pin_drop</mat-icon>
                    <div class="column">
                      <div *ngIf="metric.unitName || metric.unit" class="metric-title">
                        <strong>{{metric.unitName || metric.unit}}</strong>
                      </div>

                      <div *ngIf="metric.trackerName || metric.tracker" class="space-vertical">
                        {{metric.trackerName || metric.tracker}}
                      </div>
                    </div>
                  </div>

                  <!--User-->
                  <div class="row space-row" *ngIf="metric.userEmail">
                    <mat-icon class="center-icon space-icon"
                      [style.color]="metric.color ? metric.color : metric.payload.color">person</mat-icon>
                    <div class="column">
                      <div class="metric-title">
                        <strong>{{metric.userEmail}}</strong>
                      </div>

                    </div>
                  </div>

                  <!--Date/time-->
                  <div class="row space-row" *ngIf="metric.payload.startDate">
                    <mat-icon class="center-icon space-icon"
                      [style.color]="metric.color ? metric.color : metric.payload.color">timer</mat-icon>
                    <div class="column">
                      <div *ngIf="metric.payload.startDate">
                        <ng-container *ngIf="metric.payload.startDate && metric.payload.endDate">
                          {{ metric.payload.startDate | date: 'HH:mm:ss' }} - {{ metric.payload.endDate | date:
                          'HH:mm:ss' }}
                        </ng-container>
                        <ng-container *ngIf="!metric.payload.endDate">
                          {{ metric.payload.endDate | date: 'HH:mm:ss' }}
                        </ng-container>
                      </div>

                      <div *ngIf="metric.payload.duration" class="space-vertical">
                        <strong>{{ metric.payload.duration / 60 | number: '1.0-0' }} min</strong>
                      </div>
                    </div>
                  </div>

                  <!--Comment-->
                  <div class="row space-row row-center" *ngIf="metric.payload.comment">
                    <div class="center-icon">
                      <mat-icon [style.color]="metric.color ? metric.color : metric.payload.color">info</mat-icon>
                    </div>
                    <div class="center-text">
                      <span>{{metric.payload.comment}}</span>
                    </div>
                  </div>

                  <!--Weight / Total-->
                  <div class="row space-row">
                    <ng-container
                      *ngIf="metric.payload.weightTotal || metric.payload.weight || metric.payload.totalWeight">
                      <mat-icon class="center-icon space-icon"
                        [style.color]="metric.color ? metric.color : metric.payload.color">fitness_center</mat-icon>

                      <div class="column">
                        <div *ngIf="(metric.payload.weightTotal || metric.payload.totalWeight)"
                          class="metric-title2 space-vertical">
                          <strong>{{ 'units.total_weight' | translate }}</strong>
                        </div>
                        <div *ngIf="metric.payload.weight" class="metric-title2 space-vertical">
                          <strong>{{ 'units.weight' | translate }}</strong>
                        </div>

                        <div class="space-vertical">
                          {{ metric.payload.weightTotal || metric.payload.weight ||
                          metric.payload.totalWeight }} kg
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="metric.payload.distance">
                      <mat-icon class="center-icon space-icon space-distance"
                        [style.color]="metric.color ? metric.color : metric.payload.color">360</mat-icon>
                      <div class="column">
                        <div class="metric-title2 space-vertical">
                          <strong>Distance</strong>
                        </div>
                        <div class="space-vertical">
                          {{metric.payload.distance | number:'1.2-2'}} m
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <!--ConcreteWeight / Volume-->
                  <div class="row space-row" *ngIf="metric.payload.concreteWeight || metric.payload.volume">
                    <ng-container *ngIf="metric.payload.concreteWeight">
                      <mat-icon class="center-icon space-icon"
                        [style.color]="metric.color ? metric.color : metric.payload.color">save_alt</mat-icon>
                      <div class="column">
                        <div class="metric-title2 space-vertical">
                          <strong>{{ 'units.concrete_weight' | translate }}</strong>
                        </div>
                        <div class="space-vertical">
                          {{metric.payload.concreteWeight}} kg
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="metric.payload.volume">
                      <mat-icon [ngClass]="metric.payload.concreteWeight ? 'space-beton' : ''"
                        class="center-icon space-icon"
                        [style.color]="metric.color ? metric.color : metric.payload.color">water_drop
                      </mat-icon>

                      <div class="column">
                        <div class="metric-title2 space-vertical">
                          <strong>Volume</strong>
                        </div>

                        <div class="space-vertical">
                          {{metric.payload.volume}} m3
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <!--task-->
                  <div class="row space-row" *ngIf="metric.payload.task">
                    <mat-icon class="center-icon space-icon"
                      [style.color]="metric.color ? metric.color : metric.payload.color">calendar_today
                    </mat-icon>

                    <div class="column">
                      <div class="metric-title2 space-vertical">
                        {{metric.payload.planning}}
                      </div>

                      <div class="space-vertical">
                        <strong>{{metric.payload.task}}</strong>
                      </div>
                    </div>
                  </div>

                  <!--Battery shackle/tracker-->
                  <div class="row space-row" *ngIf="metric.payload.trackerBattery">
                    <ng-container *ngIf="metric.payload.trackerBattery">
                      <mat-icon class="center-icon space-icon"
                        [ngStyle]="{ 'color': getBatteryColor(metric.payload.trackerBattery) }">
                        battery_full
                      </mat-icon>

                      <div class="column">
                        <div class="metric-title2 space-vertical">
                          <strong>{{"units.tracker" | translate}}</strong>
                        </div>

                        <div class="space-vertical">
                          {{metric.payload.trackerBattery.toFixed(2)}} %
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="metric.payload.shackleBattery !== undefined">
                      <mat-icon class="space-beton center-icon space-icon" svgIcon="shackle_full"
                        [ngStyle]="{ 'color': getShackleColor(metric.payload.shackleBattery) }">
                      </mat-icon>

                      <div class="column space-add">
                        <div class="metric-title2 space-vertical">
                          <strong>Peson</strong>
                        </div>

                        <div class="space-vertical">
                          {{metric.payload.shackleBattery.toFixed(2)}} %
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>

                <!-- Data Raw -->
                <div *ngIf="showRawData">
                  <img *ngIf="metric.thumbnail" [src]="metric.thumbnail" (click)="onImgClick()">
                  <div class="row space">
                    <div class="column">
                      <div *ngIf="metric.payload.title" class="metric-title">
                        <strong>{{metric.payload.title}}</strong>
                      </div>

                      <div *ngIf="metric.name" class="metric-name space-vertical">
                        {{metric.name}}
                      </div>
                    </div>
                  </div>
                  <hr>

                  <div class="raw-data">
                    <div *ngFor="let item of metric.data">
                      {{item.key}}: {{item.value}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <div class="periods-wrapper" [style.left]="hourWidth + 'px'" [style.width]="(calendarWidth - hourWidth) + 'px'"
    [ngClass]="{'month-only': isGreaterThan('month') && isSmallerThan('threeYears'), 'year-only': isGreaterThan('year')}">
    <div class="periods-header" [style.left]="(scrollLeft) * -1 + 'px'">

      <!-- Années -->
      <div *ngFor="let year of years; let index; trackBy: trackByDay" class="year period" (click)="onZoom('year', year)"
        [style.width]="year.size * hourSize + 'px'" [style.left]="(year.position * hourSize) + 'px'">
        <div class="label">{{year.label}}</div>
      </div>

      <!-- Mois -->
      <div *ngFor="let month of months; let index; trackBy: trackByDay" class="month period"
        (click)="onZoom('month', month)" [style.width]="month.size * hourSize + 'px'"
        [style.left]="(month.position * hourSize) + 'px'">
        <div class="label">{{month.label}}</div>
      </div>

      <!-- Semaines -->
      <ng-container *ngIf="isSmallerThan('quarter')">
        <div *ngFor="let week of weeks; let index; trackBy: trackByDay" class="week period"
          (click)="onZoom('week', week)" [style.width]="week.size * hourSize + 'px'"
          [style.left]="(week.position * hourSize) + 'px'">
          <div class="label">{{(week.size * hourSize < 60) ? week.shortLabel : week.label}}</div>
          </div>
      </ng-container>

      <!-- Jours -->
      <ng-container *ngIf="isSmallerThan('quarter')">
        <div *ngFor="let day of days; let index; trackBy: trackByDay" class="day period" (click)="onZoom('day', day)"
          [style.width]="hourSize * hoursPerDay + 'px'" [style.left]="(day.position * hourSize) + 'px'">
          <div class="label">{{day.label}}</div>
        </div>
      </ng-container>
    </div>
  </div>
</div>